import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import {
  FileInput,
  form,
  Form as AppForm,
  Select
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { importOutgoingQuoteLineItems } from "MODULES/IncomingQuotes/actions";
import { Warning } from "MODULES/shared/components";
import { toOptions } from "LIB/forms";
import { properCase } from "LIB/formatters/text";
import {
  AS_IS,
  EXCHANGE_ONLY,
  INCIDENT_RELATED,
  INCOMING_LINE_ITEMS,
  MAKE_OFFER,
  NOT_AWAITING_REPLY,
  OFFER
} from "MODULES/IncomingQuotes/constants";
import { QUOTE_TYPE } from "MODULES/OutgoingQuotes/constants";
import { removeKeys } from "LIB/removeKey";
import { AWAITING_REPLY } from "MODULES/RepairQuotes/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";

const formName = "importOQItems";

function Form(props) {
  const QUOTE_TYPES = removeKeys(INCOMING_LINE_ITEMS.quoteType, [
    AWAITING_REPLY,
    INCIDENT_RELATED,
    NOT_AWAITING_REPLY,
    MAKE_OFFER,
    OFFER,
    AS_IS,
    EXCHANGE_ONLY
  ]);

  const FILES = {
    no_quote:
      "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/No_Quote_Template.csv",
    standard:
      "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/Blank_Standard_Outgoing_Quote_Template_v2.csv"
  };

  const WARNINGS = {
    no_quote: (
      <React.Fragment>
        Please use the following column header fields for the No Quote import:
        <br />
        <br />
        <strong>part_number</strong> (required field).
        <br />
        <br />
        Ensure the import file is in .csv format.
      </React.Fragment>
    ),
    standard: (
      <React.Fragment>
        Please use the following column headers for the Standard Outgoing Quote
        import:
        <br />
        <br />
        <strong>part_number</strong> (required field: unique identifier for the
        part).
        <br />
        <strong>serial_number</strong> (optional field).
        <br />
        <strong>description</strong> (optional field: only needed if part_number
        is new to the system).
        <br />
        <strong>cond</strong> (required field: acceptable codes: NE, OH, SV, BT,
        SV TOOLING, AR, BR).
        <br />
        <strong>qty</strong> (required field: quantity).
        <br />
        <strong>cost</strong> (optional field: can be 0 or left blank).
        <br />
        <strong>tag_date</strong> (optional field: can be left blank; date
        format is MM/DD/YYYY).
        <br />
        <strong>lead_time</strong> (optional field: can be 0 or blank).
        <br />
        <br />
        Ensure the import file is in .csv format.
      </React.Fragment>
    )
  };

  const fileLink = FILES[props.getFieldValue(QUOTE_TYPE)];

  return (
    <AppForm {...props}>
      <AppForm.Body>
        {props.getFieldValue(QUOTE_TYPE) && (
          <FormRow>
            <Warning>{WARNINGS[props.getFieldValue(QUOTE_TYPE)]}</Warning>
          </FormRow>
        )}
        <FormRow>
          <Col md={6}>
            <Field
              name={QUOTE_TYPE}
              component={Select}
              options={toOptions(QUOTE_TYPES)}
              label={properCase(QUOTE_TYPE)}
              required
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={8}>
            <Field
              name="file"
              component={FileInput}
              label="Upload Attachment"
              required
            />
          </Col>
        </FormRow>
        {fileLink && (
          <FormRow>
            <Col md={8} mdOffset={2}>
              <a href={fileLink} target="_blank" rel="noopener noreferrer">
                Template
              </a>
            </Col>
          </FormRow>
        )}
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(importOutgoingQuoteLineItems(data))
}))(
  form({
    form: formName
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/ImportOutgoingQuote/Form.jsx